import type { HttpClient } from '@store/base';
import { GetGoodsRankingsRequest, GetGoodsRankingsResponse } from '../../model';

/**
 * 한샘 랭킹 상품 TOP100 조회 (HSMALL-16671).
 *
 * 카테고리 네비게이션·칩 목록은 **다른 서비스**(content-info-service)에 있다.
 * `GetRankingCategoriesGateway`(@store/content) 와 짝으로 쓴다.
 */
export class GetGoodsRankingsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsRankingsRequest) {
    return await this.httpClient.request<GetGoodsRankingsResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/rankings`,
      // GET 은 BaseAxios 가 body 를 쿼리로 직렬화한다 (undefined 필드는 제외)
      body: req,
    });
  }
}
